import React from "react";

function Header(){
    return(
        <header>
        <div className="shape mb-5"></div>
      </header>
    )
}
export default Header;